import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const PartnerFileList = ({
  apiRef,
  columns,
  files,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
}) => {
  return (
    <div style={{ display: 'flex', height: '350px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          apiRef={apiRef}
          rows={files ? files : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '거래처_첨부파일_리스트' },
          }}
          loading={loading}
          editMode="row"
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
          initialState={{ pinnedColumns: { right: ['actions'] } }}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
        />
      </div>
    </div>
  );
};

export default PartnerFileList;
